import React, { useState } from "react";

export default function ReferralSource({ register, errors }) {
  const fieldName = "referralSource";
  const [selectedOption, setSelectedOption] = useState("");

  return (
    <fieldset>
      <legend className="wdc-field-label">
        And finally, where did you hear about us?
      </legend>
      <div className="space-y-2.5">
        {[
          { value: "googleSearch", label: "Google search" },
          { value: "recommendation", label: "Recommendation / word of mouth" },
          { value: "blogArticle", label: "One of your blog articles" },
          { value: "socialMedia", label: "Social media" },
          { value: "email", label: "You sent me an email" },
          { value: "other", label: "Other" },
        ].map((option) => (
          <label
            key={option.value}
            htmlFor={`${fieldName}-${option.value}`}
            className="wdc-option"
          >
            <input
              id={`${fieldName}-${option.value}`}
              type="radio"
              value={option.value}
              className="wdc-check"
              onChange={() => setSelectedOption(option.value)}
              {...register(`${fieldName}.choice`, { required: true })}
            />
            <span className="wdc-option-label">{option.label}</span>
          </label>
        ))}

        {errors[fieldName] && (
          <span className="wdc-error">This field is required</span>
        )}

        {selectedOption === "other" && (
          <div className="mt-3">
            <input
              type="text"
              placeholder="Please specify"
              className="wdc-field"
              {...register(`${fieldName}.otherText`)}
            />
          </div>
        )}
      </div>
    </fieldset>
  );
}
